export const environment = {
  production: true,
  apiUrl: 'https://flycarapi-test.avis.co.il/api/kiosk',
  earlyCheckInBaseUrl: 'https://flycarapi-test.avis.co.il/api/early-check-in',
  externalPaymentBaseUrl: 'https://flycarapi-test.avis.co.il/api/external/externalSite',
  kioskBaseUrl: 'https://rent-checkin-test.avis.co.il',
  version: '1.6.6',
  contractData: {
    companyId: '900',
    deskCode: 1,
    branchCode: 1,
    baseUrl: 'https://us-central1-flycartest-99477.cloudfunctions.net',
  },
  firebase: {
    apiKey: 'AIzaSyBqNZM1kR4MsZwSMPOicUkFubXxF5Fov3Y',
    authDomain: 'flycartest-99477.firebaseapp.com',
    databaseURL: 'https://flycartest-99477.firebaseio.com',
    projectId: 'flycartest-99477',
    storageBucket: 'flycartest-99477.appspot.com',
    messagingSenderId: '354351551164',
    appId: '1:354351551164:web:b1080a9e0f6938f86076b9',
  },
  tafniteRequiredData: {
    DocumentName: 'רשיון נהיגה',
    PassportDocumentName: 'דרכון',
    ArchiveCode: 143,
    ArchiveKeywords: {
      Hevrea: 900,
      FrontLicense: 39500,
      BackLicense: 65800,
      AdditionalLicense: 36800,
      Passport: 5700,
    },
  },
  customAuth: {
    provider: 'microsoft.com',
    tenant: '5e2725d2-3d69-415e-b149-f3a5a88a6830',
  },
  skipScan: false,
};
